!function (e, a) {
  "object" == typeof exports && "undefined" != typeof module ? module.exports = a() : "function" == typeof define && define.amd ? define(a) : (e.ReactIntlLocaleData = e.ReactIntlLocaleData || {}, e.ReactIntlLocaleData.ms = a());
}(this, function () {
  "use strict";

  return [{
    locale: "ms",
    pluralRuleFunction: function pluralRuleFunction(e, a) {
      return a && 1 == e ? "one" : "other";
    },
    fields: {
      year: {
        displayName: "tahun",
        relative: {
          0: "tahun ini",
          1: "tahun depan",
          "-1": "tahun lalu"
        },
        relativeTime: {
          future: {
            other: "dalam {0} tahun"
          },
          past: {
            other: "{0} tahun lalu"
          }
        }
      },
      "year-short": {
        displayName: "thn",
        relative: {
          0: "thn ini",
          1: "thn depan",
          "-1": "thn lepas"
        },
        relativeTime: {
          future: {
            other: "dalam {0} thn"
          },
          past: {
            other: "{0} thn lalu"
          }
        }
      },
      month: {
        displayName: "bulan",
        relative: {
          0: "bulan ini",
          1: "bulan depan",
          "-1": "bulan lalu"
        },
        relativeTime: {
          future: {
            other: "dalam {0} bulan"
          },
          past: {
            other: "{0} bulan lalu"
          }
        }
      },
      "month-short": {
        displayName: "bln",
        relative: {
          0: "bln ini",
          1: "bln depan",
          "-1": "bln lalu"
        },
        relativeTime: {
          future: {
            other: "dlm {0} bln"
          },
          past: {
            other: "{0} bln lalu"
          }
        }
      },
      day: {
        displayName: "hari",
        relative: {
          0: "hari ini",
          1: "esok",
          2: "lusa",
          "-2": "kelmarin",
          "-1": "semalam"
        },
        relativeTime: {
          future: {
            other: "dalam {0} hari"
          },
          past: {
            other: "{0} hari lalu"
          }
        }
      },
      "day-short": {
        displayName: "hari",
        relative: {
          0: "hari ini",
          1: "esok",
          2: "lusa",
          "-2": "kelmarin",
          "-1": "semlm"
        },
        relativeTime: {
          future: {
            other: "dlm {0} hari"
          },
          past: {
            other: "{0} hari lalu"
          }
        }
      },
      hour: {
        displayName: "jam",
        relative: {
          0: "jam ini"
        },
        relativeTime: {
          future: {
            other: "dalam {0} jam"
          },
          past: {
            other: "{0} jam lalu"
          }
        }
      },
      "hour-short": {
        displayName: "jam",
        relative: {
          0: "jam ini"
        },
        relativeTime: {
          future: {
            other: "dlm {0} jam"
          },
          past: {
            other: "{0} jam lalu"
          }
        }
      },
      minute: {
        displayName: "minit",
        relative: {
          0: "pada minit ini"
        },
        relativeTime: {
          future: {
            other: "dalam {0} minit"
          },
          past: {
            other: "{0} minit lalu"
          }
        }
      },
      "minute-short": {
        displayName: "min",
        relative: {
          0: "pada minit ini"
        },
        relativeTime: {
          future: {
            other: "dlm {0} min"
          },
          past: {
            other: "{0} min lalu"
          }
        }
      },
      second: {
        displayName: "saat",
        relative: {
          0: "sekarang"
        },
        relativeTime: {
          future: {
            other: "dalam {0} saat"
          },
          past: {
            other: "{0} saat lalu"
          }
        }
      },
      "second-short": {
        displayName: "saat",
        relative: {
          0: "sekarang"
        },
        relativeTime: {
          future: {
            other: "dlm {0} saat"
          },
          past: {
            other: "{0} saat lalu"
          }
        }
      }
    }
  }, {
    locale: "ms-Arab",
    pluralRuleFunction: function pluralRuleFunction(e, a) {
      return "other";
    },
    fields: {
      year: {
        displayName: "Year",
        relative: {
          0: "this year",
          1: "next year",
          "-1": "last year"
        },
        relativeTime: {
          future: {
            other: "+{0} y"
          },
          past: {
            other: "-{0} y"
          }
        }
      },
      "year-short": {
        displayName: "Year",
        relative: {
          0: "this year",
          1: "next year",
          "-1": "last year"
        },
        relativeTime: {
          future: {
            other: "+{0} y"
          },
          past: {
            other: "-{0} y"
          }
        }
      },
      month: {
        displayName: "Month",
        relative: {
          0: "this month",
          1: "next month",
          "-1": "last month"
        },
        relativeTime: {
          future: {
            other: "+{0} m"
          },
          past: {
            other: "-{0} m"
          }
        }
      },
      "month-short": {
        displayName: "Month",
        relative: {
          0: "this month",
          1: "next month",
          "-1": "last month"
        },
        relativeTime: {
          future: {
            other: "+{0} m"
          },
          past: {
            other: "-{0} m"
          }
        }
      },
      day: {
        displayName: "Day",
        relative: {
          0: "today",
          1: "tomorrow",
          "-1": "yesterday"
        },
        relativeTime: {
          future: {
            other: "+{0} d"
          },
          past: {
            other: "-{0} d"
          }
        }
      },
      "day-short": {
        displayName: "Day",
        relative: {
          0: "today",
          1: "tomorrow",
          "-1": "yesterday"
        },
        relativeTime: {
          future: {
            other: "+{0} d"
          },
          past: {
            other: "-{0} d"
          }
        }
      },
      hour: {
        displayName: "Hour",
        relative: {
          0: "this hour"
        },
        relativeTime: {
          future: {
            other: "+{0} h"
          },
          past: {
            other: "-{0} h"
          }
        }
      },
      "hour-short": {
        displayName: "Hour",
        relative: {
          0: "this hour"
        },
        relativeTime: {
          future: {
            other: "+{0} h"
          },
          past: {
            other: "-{0} h"
          }
        }
      },
      minute: {
        displayName: "Minute",
        relative: {
          0: "this minute"
        },
        relativeTime: {
          future: {
            other: "+{0} min"
          },
          past: {
            other: "-{0} min"
          }
        }
      },
      "minute-short": {
        displayName: "Minute",
        relative: {
          0: "this minute"
        },
        relativeTime: {
          future: {
            other: "+{0} min"
          },
          past: {
            other: "-{0} min"
          }
        }
      },
      second: {
        displayName: "Second",
        relative: {
          0: "now"
        },
        relativeTime: {
          future: {
            other: "+{0} s"
          },
          past: {
            other: "-{0} s"
          }
        }
      },
      "second-short": {
        displayName: "Second",
        relative: {
          0: "now"
        },
        relativeTime: {
          future: {
            other: "+{0} s"
          },
          past: {
            other: "-{0} s"
          }
        }
      }
    }
  }, {
    locale: "ms-BN",
    parentLocale: "ms"
  }, {
    locale: "ms-SG",
    parentLocale: "ms"
  }];
});